// @ts-nocheck
// set multiple fields
export const SET_MULTIPLE_FIELDS_EVENT_REQUEST =
  "SET_MULTIPLE_FIELDS_EVENT_REQUEST";

// fetch event request
export const FETCH_NEW_EVENT_REQUEST = "FETCH_NEW_EVENT_REQUEST";
export const FETCH_NEW_EVENT_SUCCESS = "FETCH_NEW_EVENT_SUCCESS";
export const FETCH_NEW_EVENT_FAILURE = "FETCH_NEW_EVENT_FAILURE";

// event search
export const SEARCH_NEW_EVENT_REQUEST = "SEARCH_NEW_EVENT_REQUEST";
export const SEARCH_NEW_EVENT_SUCCESS = "SEARCH_NEW_EVENT_SUCCESS";
export const SEARCH_NEW_EVENT_FAILURE = "SEARCH_NEW_EVENT_FAILURE";

// assign client
export const ASSIGN_CLIENT_REQUEST = "ASSIGN_CLIENT_REQUEST";
export const ASSIGN_CLIENT_SUCCESS = "ASSIGN_CLIENT_SUCCESS";
export const ASSIGN_CLIENT_FAILURE = "ASSIGN_CLIENT_FAILURE";

// refresh posiitons
export const REFRESH_POSITIONS_REQUEST = "REFRESH_POSITIONS_REQUEST";
export const REFRESH_POSITIONS_SUCCESS = "REFRESH_POSITIONS_SUCCESS";
export const REFRESH_POSITIONS_FAILURE = "REFRESH_POSITIONS_FAILURE";

// update contact information
export const UPDATE_CONTACT_INFORMATION_REQUEST =
  "UPDATE_CONTACT_INFORMATION_REQUEST";
export const UPDATE_CONTACT_INFORMATION_SUCCESS =
  "UPDATE_CONTACT_INFORMATION_SUCCESS";
export const UPDATE_CONTACT_INFORMATION_FAILURE =
  "UPDATE_CONTACT_INFORMATION_FAILURE";

// update event information
export const UPDATE_EVENT_INFORMATION_REQUEST =
  "UPDATE_EVENT_INFORMATION_REQUEST";
export const UPDATE_EVENT_INFORMATION_SUCCESS =
  "UPDATE_EVENT_INFORMATION_SUCCESS";
export const UPDATE_EVENT_INFORMATION_FAILURE =
  "UPDATE_EVENT_INFORMATION_FAILURE";

// delete an event
export const DELETE_EVENT_REQUEST = "DELETE_EVENT_REQUEST";
export const DELETE_EVENT_SUCCESS = "DELETE_EVENT_SUCCESS";
export const DELETE_EVENT_FAILURE = "DELETE_EVENT_FAILURE";

// archive an event
export const ARCHIVE_EVENT_REQUEST = "ARCHIVE_EVENT_REQUEST";
export const ARCHIVE_EVENT_SUCCESS = "ARCHIVE_EVENT_SUCCESS";
export const ARCHIVE_EVENT_FAILURE = "ARCHIVE_EVENT_FAILURE";

// clear event request list
export const CLEAR_EVENT_REQUEST_LIST = "CLEAR_EVENT_REQUEST_LIST";

// update deposit  invoice status
export const UPDATE_DEPOSIT_INVOICE_STATUS_REQUEST =
  "UPDATE_DEPOSIT_INVOICE_STATUS_REQUEST";
export const UPDATE_DEPOSIT_INVOICE_STATUS_SUCCESS =
  "UPDATE_DEPOSIT_INVOICE_STATUS_SUCCESS";
export const UPDATE_DEPOSIT_INVOICE_STATUS_FAILURE =
  "UPDATE_DEPOSIT_INVOICE_STATUS_FAILURE";